import * as React from 'react';
import { useFragment } from 'react-relay';
import { Address } from '@components/address';
import { locationBlockFragment } from './LocationBlock.relay';
import { locationBlockClassName } from './lib/LocationBlockStyles';
import type { LocationBlockPropsType } from './types';

const LocationBlock: React.FC<LocationBlockPropsType> = ( props: LocationBlockPropsType ) => {
    const contentBlock = useFragment( locationBlockFragment, props.contentBlock );

    return (
        <div className={locationBlockClassName}>
            <div className="flex flex-row justify-between items-center max-[1100px]:flex-col-reverse max-[1100px]:[&>*]:mb-[35px] min-[701px]:[&>*]:basis-[calc(50%-20px)]">
                <div className="h-[500px] max-[1100px]:w-full [&_iframe]:border-none [&_iframe]:w-full [&_iframe]:h-full">
                    <iframe
                        src={ `https://maps.google.com/maps?q=${ contentBlock.coordinates.latitude
                        },${ contentBlock.coordinates.longitude
                        }&z=16&output=embed` }
                    />
                </div>
                <Address
                    address={ contentBlock.address }
                    phoneLabel={ contentBlock.phoneLabel }
                    faxLabel={ contentBlock.faxLabel }
                    emailLabel={ contentBlock.emailLabel }
                />
            </div>
        </div>
    );
};

export { LocationBlock };
